import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ContentHeader from '../common/template/contentHeader'
import Content from '../common/template/content'

import Tabs from '../common/tab/tabs'
import TabsHeader from '../common/tab/tabsHeader'
import TabsContent from '../common/tab/tabsContent'
import TabHeader from '../common/tab/tabHeader'
import TabContent from '../common/tab/tabContent'
import { gerarCarnes, init, getUnidadesAtivas, gerarPDFSUnidade, imprimirCarneAvulso } from './rotina_automaticaAction'
import If from '../common/operador/if'

import API from '../consts'
import axios from "axios";
import { toastr } from "react-redux-toastr";

class RotinasAutomaticas extends Component {

  componentWillMount() {
    this.props.init()
  }

  constructor(props) {
    super(props);
    this.state = {
      List: [],
      MasterChecked: false,
      SelectedList: [],
    };
  }


  btnGeraCarneIsEnable() {
    return this.props.rotina_automatica.process_geracao_carne === 'N' ? false : true;
  }

  isGerandoPFD() {
    return this.props.rotina_automatica.processo_geracao_pdf_carne === 'N' ? false : true;
  }

  gerarUnidades() {
    let unidades = this.props.rotina_automatica.unidades_ativas;
    if (unidades !== null && unidades !== undefined && Array.isArray(unidades)) {
      return unidades.map(element => (
        <option value={element.id_unidade_controle}>{`${element.nome} - ${element.cnpj}`}</option>
      ))
    }

  }

  gerarMeses(titulo, name, valueMes, pRef) {
    return <div class="col-sm-2">
      <div class="form-group">
        <label>{titulo}</label>
        <select class="form-control" name={name} ref={(c) => pRef = c} >
          <option value='0' selected={valueMes === '0' ? true : false}>Janeiro</option>
          <option value='1' selected={valueMes === '1' ? true : false}>Fevereiro</option>
          <option value='2' selected={valueMes === '2' ? true : false}>Março</option>
          <option value='3' selected={valueMes === '3' ? true : false}>Abril</option>
          <option value='4' selected={valueMes === '4' ? true : false}>Maio</option>
          <option value='5' selected={valueMes === '5' ? true : false}>Junho</option>
          <option value='6' selected={valueMes === '6' ? true : false}>Julho</option>
          <option value='7' selected={valueMes === '7' ? true : false}>Agosto</option>
          <option value='8' selected={valueMes === '8' ? true : false}>Setembro</option>
          <option value='9' selected={valueMes === '9' ? true : false}>Outubro</option>
          <option value='10' selected={valueMes === '10' ? true : false}>Novembro</option>
          <option value='11' selected={valueMes === '11' ? true : false}>Dezembro</option>
        </select>
      </div>
    </div>
  }

  getEstruturaAno(AnoSelect) {
    let AnoAtual = new Date().getFullYear();
    let ArrAnos = [];
    ArrAnos.push(AnoAtual);
    ArrAnos.push(AnoAtual + 1);
    ArrAnos.push(AnoAtual + 2);
    ArrAnos.push(AnoAtual + 3);
    ArrAnos.push(AnoAtual + 4);

    return ArrAnos.map(item => (
      <option value={item} selected={item === parseInt(AnoSelect) ? true : false} >{item}</option>
    ))
  }

  gerarAno(titulo, name, anoSelec, pRef) {
    return <div class="col-sm-2">
      <div class="form-group">
        <label>{titulo}</label>
        <select class="form-control" name={name} ref={(c) => pRef = c} >
          {this.getEstruturaAno(anoSelec)}
        </select>
      </div>
    </div>
  }


  onSubmit = (event) => {
    event.preventDefault();
    let formData = new FormData(event.currentTarget);
    let data = {}
    for (let [key, value] of formData.entries()) {
      data[key] = value;

    }
    this.props.gerarCarnes(data);
  }

  onSubmitPDF = (event) => {
    event.preventDefault();
    let formData = new FormData(event.currentTarget);
    let data = {}
    for (let [key, value] of formData.entries()) {
      data[key] = value;
    }
    this.props.gerarPDFSUnidade(data);
  }

  getDataFormatada(data) {
    let ArrDt = data.split(' ')[0].split('-')
    return `${ArrDt[2]}/${ArrDt[1]}/${ArrDt[0]}`
  }

  // FUNCOES DO SELECT DOS BOLETOS 
  onMasterCheck(e) {
    let tempList = this.state.List;
    // Check/ UnCheck All Items
    tempList.map((user) => (user.selected = e.target.checked));

    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      List: tempList,
      SelectedList: this.state.List.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.List;
    let listCheck = [];
    tempList.map((user) => {
      if (user.id === item.id) {
        user.selected = e.target.checked;
      }
    });
    this.setState({ ...this.state, SelectedList: this.state.List.filter((e) => e.selected) })

  }

  buscarBoletos(e) {
    axios['post'](`${API.API_URL}/bolavulsocliente/naocancelado/naopago`,
      {
        "unidade": parseInt(this.unidade_pdf_avulso.value),
        "id_cliente": parseInt(this.codCliente.value),
      },
      {
        headers: {
          'Accept': 'application/json',
        }
      })
      .then(response => {
        if (response.data.status == 200) {
          this.setState({ ...this.state, List: response.data.lista })
        } if (response.data.status == 400) {
          toastr.error('Erro', response.data.erro);
        }
      }).catch(e => {
        toastr.error('Erro', e.message)
      })


  }

  imprimir(e) {
    e.preventDefault();

    if (this.state.SelectedList.length == 0) {
      toastr.error('Erro', "Nenhum boleto selecionado, selecione pelo menos um boleto para gerar a impressão!");
      return;
    }

    axios['post'](`${API.API_URL}/printAvulso/carne`, { unidade: this.unidade_pdf_avulso.value, lista: this.state.SelectedList }, {
      headers: {
        /*"unidade": this.unidade_pdf_avulso.value,
        "lista": JSON.stringify(this.state.SelectedList),
        'Accept': 'application/pdf',*/
      }, responseType: 'arraybuffer'
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
        window.open(url, "_blank");
      }).catch(e => {
        toastr.error('Erro', e.message)
      })

  }


  render() {
    let dt = new Date();
    let mesSelec = dt.getMonth();
    let anoSelc = dt.getFullYear();
    return (
      <div>
        <ContentHeader title='Rotinas Automáticas' small='' />
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label='Carnês' icon='cogs' target='rotinas' />
              <TabHeader label='PDF' icon='file' target='pdfs' />
              <TabHeader label='Imprimir Avulso como Carnê' icon='file' target='pdfsavulso' />
            </TabsHeader>
            <TabsContent>

              <TabContent id='rotinas'>
                <div className="content">
                  <form onSubmit={this.onSubmit}>
                    <div>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Unidade</label>
                          <select class="form-control" name='unidade' ref={(x) => this.unidade = x} required >
                            <option value=''></option>
                            {this.gerarUnidades()}
                          </select>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Id Cliente</label>
                          <input type="number" name='id_cliente' className="form-control input-sm" placeholder="Digite o ID do cliente"
                          />
                        </div>
                      </div>

                      {this.gerarMeses('Mêses Início', 'mes_inicio', mesSelec.toString(), this.mes_inicio)}
                      {this.gerarAno('Ano Início', 'ano_inicio', anoSelc.toString(), this.ano_inicio)}

                      {this.gerarMeses('Mêses Término', 'mes_termino', mesSelec.toString(), this.mes_termino)}
                      {this.gerarAno('Ano Término', 'ano_termino', (anoSelc + 1).toString(), this.ano_termino)}
                    </div>

                    <div class="col-sm-12">
                      <button type='submit' className="btn btn-primary" disabled={this.btnGeraCarneIsEnable()}  >
                        <i className="fa fa-book"></i><span className='space-icon'>Gerar Carnês</span></button>

                      <If test={this.props.rotina_automatica.process_geracao_carne === 'S'}>
                        <button className="btn btn-warning" onClick={(e) => { e.preventDefault() }}>
                          <i class="fa fa-spinner fa-pulse">
                          </i><span className='space-icon'>Processo de Geração dos carnês em andamento...</span></button>
                      </If>
                    </div>
                  </form>
                </div>
              </TabContent>

              <TabContent id='pdfs'>
                <form onSubmit={this.onSubmitPDF}>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Unidade</label>
                      <select class="form-control" name='unidade_pdf' ref={(y) => this.unidade_pdf = y} required disabled={this.isGerandoPFD()} >
                        <option value=''></option>
                        {this.gerarUnidades()}
                      </select>
                    </div>
                  </div>
                  <button type='submit' className="btn btn-primary" disabled={this.isGerandoPFD()} >
                    <i className="fa fa-book"></i><span className='space-icon'>Gerar PDFs</span></button>
                  <If test={this.props.rotina_automatica.processo_geracao_pdf_carne === 'S'}>
                    <button className="btn btn-warning" onClick={(e) => { e.preventDefault() }}>
                      <i class="fa fa-spinner fa-pulse">
                      </i><span className='space-icon'>Processo de Geração dos pdfs dos carnês em andamento...</span></button>
                  </If>
                </form>

              </TabContent>

              <TabContent id='pdfsavulso'>
                <div className="content">
                  <div className="row">

                    <div class="col-sm-12">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Unidade</label>
                          <select class="form-control" name='unidade_pdf_avulso' ref={(b) => this.unidade_pdf_avulso = b} required >
                            <option value=''></option>
                            {this.gerarUnidades()}
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <label>Código Cliente</label>
                        <div id="custom-search-input">
                          <div className="input-group col-md-12">
                            <div className="input-group col-md-12">
                              <input type="number" ref={(c) => this.codCliente = c} className="form-control input-sm" placeholder="Digite o ID do cliente" />
                              <span className="input-group-btn">
                                <button className="btn btn-info btn-sm" type="button" onClick={(e) => this.buscarBoletos(e)}>
                                  <i className="glyphicon glyphicon-search"></i>&nbsp;Buscar Boletos
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <If test={this.state.List.length > 0}>
                      <div className="col-sm-12">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={this.state.MasterChecked}
                                  id="mastercheck"
                                  onChange={(e) => this.onMasterCheck(e)}
                                />
                              </th>
                              <th scope="col">Codigo</th>
                              <th scope="col">Cliente</th>
                              <th scope="col">Valor</th>
                              <th scope="col">Vencimento</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.List.map((boleto) => (
                              <tr key={boleto.id} className={boleto.selected ? "selected" : ""}>
                                <th scope="row">
                                  <input
                                    type="checkbox"
                                    checked={boleto.selected}
                                    className="form-check-input"
                                    id="rowcheck{user.id}"
                                    onChange={(e) => this.onItemCheck(e, boleto)}
                                  />
                                </th>
                                <td>{boleto.id}</td>
                                <td>{boleto.nome_cliente}</td>
                                <td>{boleto.valor}</td>
                                <td>{this.getDataFormatada(boleto.dt_vencimento)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </If>

                    <div class="col-sm-12">
                      <button className="btn btn-primary" onClick={(e) => this.imprimir(e)} style={{ marginTop: 20 }}>
                        <i className="fa fa-book"></i><span className='space-icon'>Gera PDF</span></button>
                    </div>

                  </div>
                </div>
              </TabContent>

            </TabsContent>
          </Tabs>
        </Content>
      </div>
    )
  }
}

const mapStateToProps = state => ({ rotina_automatica: state.rotina_automatica, usuario: state.auth.user })
const mapDispatchToProps = dispatch => bindActionCreators({ gerarCarnes, init, getUnidadesAtivas, gerarPDFSUnidade, imprimirCarneAvulso }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(RotinasAutomaticas)


// WEBPACK FOOTER //
// ./src/rotinaautomatica/rotina_automatica.jsx